module.exports = __webpack_public_path__ + "static/nextcell-medical-logo-aa0483428d7f599aa5d496ee170450af.svg";